import { ActivityType } from '../../entities';
import { AreaCategory, staticMachineAreaZones } from '../zone-mappings';
import { ActivityTypeMapping } from './workout-activity-mappings';

export class MarchineZoneActivityTypeMapping {
  public static buildActivityTypeMap(): Map<ActivityType, AreaCategory[]> {
    const mapping = new Map<ActivityType, AreaCategory[]>([
      [ActivityType.Stepper, ['step']],
      [ActivityType.Elliptical, ['elliptical']],
      [ActivityType.PowerStationFitillion, ['power']],
      [ActivityType.TreadmillFitillion, ['treadmill']],
      [ActivityType.StudioBikeFitillion, ['bicycle']],
      [ActivityType.RowingAndPaddling, ['rower']],
      [ActivityType.Running, []],
      [ActivityType.StrengthTraining, []],
      [ActivityType.Cycling, []],
      [ActivityType.BuildFitillion, []],
      [ActivityType.BurnFitillion, []],
      [ActivityType.BalanceFitillion, []],
      [ActivityType.BoxingFitillion, []],
      [ActivityType.HIIT, []],
      [ActivityType.CombatAndMartialArts, []],
      [ActivityType.DanceAndAerobics, []],
      [ActivityType.Gymnastics, []],
      [ActivityType.PilatesAndYoga, []],
      [ActivityType.OtherCardio, []],
      [ActivityType.Multisport, []],
      [ActivityType.Swimming, []],
      [ActivityType.Climbing, []],
      [ActivityType.WinterSports, []],
      [ActivityType.WalkingAndHiking, []],
      [ActivityType.RacquetSport, []],
      [ActivityType.TeamSports, []],
    ]);

    for (const area of staticMachineAreaZones) {
      const mapped = ActivityTypeMapping.getActivityTypeFor(area, mapping);
      if (!mapped) {
        throw new Error(`Critical: static machine area ${area} is not mapped to an ActivityType`);
      }
    }

    return mapping;
  }
}
